<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2c"><a id="ack"></a><a id="page_vii"><span class="ash">•</span> Acknowledgments <span class="ash">•</span></a></h2><a id="page_vii">
<p class="center">A novel, particularly a first novel, is never published without many mercies, known and unknown. Thanks to Bill Reiss for taking a chance and being patient, and to Karen Wojtyla for shepherding a novice painlessly through the process. The Bridge School “older writers” served as a gracious and gratifying first audience. Blessings on you all.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?10c43d60